<template>
  <div class="dialer-keypad">
    <button
      v-for="key in keys"
      :key="key"
      type="button"
      class="dialer-keypad__key"
      @click="$store.dispatch('dialer/pressKey', key)"
    >
      {{ key }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'DialerKeypad',

  data() {
    return {
      keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
    };
  },
};
</script>

<style lang="scss" scoped>
.dialer-keypad {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, 1fr);

  &__key {
    background: #f4f4f6;
    border-radius: 8px;
    font-size: 20px;
    height: 44px;

    &:hover {
      background: #e8e8ec;
    }
  }
}
</style>
